import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=a4633da6&"
import script from "./MenuLayout.vue?vue&type=script&lang=ts&"
export * from "./MenuLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports